import ContactsToolbar from "../../components/ContactsToolbar";
import FriendsTable from "../../components/FriendsTable";
import useContactsData from "../../hooks/useContactsData";
import { useContacts } from "../../contexts/ContactsContext";
import EmptyState from "../../components/EmptyState";
import { Store } from "lucide-react";

const FriendsTab = () => {
  const { selectedShopIds } = useContacts();
  const { items, loading, reload } = useContactsData({ category: "friends" });

  return (
    <div className="flex flex-col h-full">
      <ContactsToolbar
        title="Bạn bè"
        subtitle={`${items.length} liên hệ`}
        onReload={reload}
        loading={loading}
      />
      <div className="flex-1 overflow-hidden">
        {selectedShopIds.length === 0 ? (
          <EmptyState
            icon={Store}
            title="Chưa chọn tài khoản Zalo"
            description="Chọn ít nhất 1 tài khoản từ dropdown phía trên để xem danh bạ."
          />
        ) : (
          <FriendsTable items={items} loading={loading} />
        )}
      </div>
    </div>
  );
};

export default FriendsTab;
